var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-center plan-boxes" },
    [
      _vm._l(_vm.PAYMENT_PLANS, function (plan) {
        return _c(
          "b-col",
          { key: plan.label, attrs: { cols: "12", sm: "6", xl: "4" } },
          [
            _c(
              "div",
              {
                staticClass: "plan card align-items-center mb-0",
                class: {
                  "current-plan": _vm.CURRENT_ACCOUNT_PLAN === plan.name,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "card-header w-100" },
                  [
                    _c("h6", { staticClass: "text-center bold" }, [
                      _vm._v("Expert " + _vm._s(plan.label)),
                    ]),
                    _vm._v(" "),
                    !(plan.name === _vm.freePlanName || _vm.hidePlanToggle)
                      ? _c(
                          "b-row",
                          {
                            staticClass: "small align-items-center",
                            class: { disabled: _vm.disablePlanToggle },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("application-form.annual")) +
                                "\n          "
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "mr-3 ml-2 pretty p-switch p-fill",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.planDurationMonthly,
                                      expression: "planDurationMonthly",
                                    },
                                  ],
                                  attrs: {
                                    id: plan.label + "-toggle",
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.planDurationMonthly
                                    )
                                      ? _vm._i(_vm.planDurationMonthly, null) >
                                        -1
                                      : _vm.planDurationMonthly,
                                  },
                                  on: {
                                    click: _vm.handleChangePlanDuration,
                                    change: function ($event) {
                                      var $$a = _vm.planDurationMonthly,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.planDurationMonthly =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.planDurationMonthly = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.planDurationMonthly = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "state" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "clickable ml-1",
                                      attrs: { for: plan.label + "-toggle" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("account.accountPlan.monthly")
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-block" },
                  [
                    _c("b-row", [
                      _c("p", { staticClass: "price-tag" }, [
                        _vm.showCoupon(plan)
                          ? _c(
                              "span",
                              { staticClass: "original-amount mr-2" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatMoneyValueLong")(
                                      _vm.getPlanAmount(plan, true)
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "currency" }, [_vm._v("$")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "amount" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("formatMoneyValueLong")(
                                  _vm.getPlanAmount(plan),
                                  false
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "regularity" }, [
                          _vm._v(
                            "/" +
                              _vm._s(
                                _vm.planDurationMonthly
                                  ? _vm.$t(
                                      "account.accountPlan.monthlyAbreviation"
                                    )
                                  : _vm.$t(
                                      "account.accountPlan.yearlyAbreviation"
                                    )
                              )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.showCoupon(plan)
                      ? _c(
                          "b-row",
                          [
                            _c("i18n", {
                              staticClass: "bold text-primary",
                              attrs: {
                                tag: "p",
                                path: "account.accountPlan.perks.youHaveACoupon",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "amount",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.couponAmountText) +
                                            "\n            "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("account-plan-perks", { attrs: { plan: plan } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column align-items-center text-center mt-3",
                        class: { invisible: plan.name === _vm.freePlanName },
                      },
                      [
                        _vm.withSession
                          ? [
                              _vm.CURRENT_ACCOUNT_PLAN === plan.name
                                ? [
                                    _vm.IS_CURRENT_USER_SUBSCRIBED
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center text-center",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c("notification-popover", {
                                              attrs: {
                                                triggers:
                                                  _vm.IS_CURRENT_USER_PAYER
                                                    ? ""
                                                    : "hover",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "popoverContent",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "account.accountPlan.perks.emptySubscriptionsMessage"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "popoverTarget",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "simple-button",
                                                          {
                                                            attrs: {
                                                              loading:
                                                                _vm.cancelingPlan,
                                                              type: "danger",
                                                              "class-name":
                                                                "btn-sm cancel-plan bold",
                                                              disabled:
                                                                !_vm.IS_CURRENT_USER_PAYER ||
                                                                _vm.loading,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.handleCancelPlan,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.words.cancel"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center text-center",
                                            attrs: { cols: "4" },
                                          },
                                          [
                                            _c("notification-popover", {
                                              attrs: {
                                                triggers:
                                                  _vm.HAS_CURRENT_USER_PAYMENT_METHODS &&
                                                  !_vm.disableSubscribeNotPayer
                                                    ? ""
                                                    : "hover",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "popoverContent",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.subscribeButtonTooltipText
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "popoverTarget",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "simple-button",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.disableSubscribe,
                                                              "class-name":
                                                                "select-plan btn-sm bold",
                                                              loading:
                                                                _vm.isSubscribing,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSelectPlan(
                                                                  "renew"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "global.words.renew"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                  ]
                                : [
                                    _c("notification-popover", {
                                      attrs: {
                                        triggers:
                                          _vm.HAS_CURRENT_USER_PAYMENT_METHODS &&
                                          !_vm.disableSubscribeNotPayer
                                            ? ""
                                            : "hover",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "popoverContent",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.subscribeButtonTooltipText
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "popoverTarget",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "simple-button",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.disableSubscribe,
                                                      "class-name":
                                                        "select-plan btn-sm",
                                                      loading:
                                                        _vm.isSubscribing,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSelectPlan(
                                                          "subscribe"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.words.subscribe"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                            ]
                          : [
                              _c("notification-popover", {
                                attrs: {
                                  triggers:
                                    _vm.HAS_CURRENT_USER_PAYMENT_METHODS &&
                                    !_vm.disableSubscribeNotPayer
                                      ? ""
                                      : "hover",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "popoverContent",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.subscribeButtonTooltipText
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "popoverTarget",
                                      fn: function () {
                                        return [
                                          _c(
                                            "simple-button",
                                            {
                                              attrs: {
                                                disabled: _vm.disableSubscribe,
                                                "class-name":
                                                  "select-plan btn-sm",
                                                loading: _vm.isSubscribing,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleSelectPlan(
                                                    "subscribe"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.words.subscribe"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.CURRENT_ACCOUNT_PLAN === plan.name
              ? _c(
                  "p",
                  {
                    staticClass: "font-sm bold text-primary m-0 text-center",
                    staticStyle: { padding: "0.375rem 0.75rem" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("account.accountPlan.yourCurrentPlan")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      _vm._v(" "),
      _c("cancel-plan-confirmation", {
        attrs: {
          show: _vm.showCancelModal,
          loading: _vm.cancelingPlan,
          "is-current-subscription": "",
        },
        on: {
          "update:show": function ($event) {
            _vm.showCancelModal = $event
          },
          "cancel-plan": _vm.cancelPlan,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }